import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";

export const usePageTitle = (fr, en) => {
  const { lang } = useLanguage();
  useEffect(() => {
    const label = lang === "en" ? en || fr : fr;
    document.title = label ? `Orbit — ${label}` : "Orbit";
  }, [lang, fr, en]);
};
